/**
 * @file       ChangePassword.css
 * @author     Danny Akbarzadeh <danny@kingsds.network>
 *             Robert Mirandola <robert@distributive.network>
 *              
 * @date       July 2022
 *             April 2023
 *
 *             Styling for change password form on user page
 */
 
.change-password {
  margin-top: 1.5%;
}

.success-message {
  margin: 0;
  padding-top: 0.5rem;
  color: var(--content-hue-dark);
}

#change-password .form-row:nth-child(3) .inlineinput:not(:first-child) {
  min-width: 28%;
  max-width: 28%;
}

#password-save {
  margin-top: 2%;
}
